import { IGroupChatData } from "@home-health-notify/domain";
import { Box } from "@mui/material";
import PatientStatusImage from "../../../common/PatientStatusImage";
import { GROUP_AVATAR_SIZE } from "../../../utils/AvatarUtils";
import { StatusImgOutline } from "./PatientGroupChatListItem.style";
import PatientTitle from "./PatientTitle";
import ServicesToPatient from "./ServicesToPatient";

const PatientCompactContent = ({ chatData }: { chatData: IGroupChatData }) => {
  const status = chatData.groupInfo.patientStatus;
  return (
    <>
      <StatusImgOutline>
        <PatientStatusImage
          status={status}
          size={GROUP_AVATAR_SIZE.SMALL}
          testId="status-img"
        />
      </StatusImgOutline>
      <Box
        sx={{
          flexDirection: "column",
          display: "flex",
          marginLeft: "7px",
        }}
      >
        <PatientTitle
          title={chatData.groupInfo.name}
          mrn={chatData.groupInfo.mrn}
        />
        <ServicesToPatient
          servicesToPatient={chatData.groupInfo.servicesToPatient}
        />
      </Box>
    </>
  );
};

export default PatientCompactContent;
